/**
 * Content-Design-authored copy for the dedicated confirm-details route
 * (TG-15, ADR-20261001-rjj8). No screens/*.md doc exists for this screen
 * yet — the source is the real, already-approved prototype itself,
 * `docs/ux-review/design_handoff_renewals_portal/prototypes/Screen3-RenewalFlow.dc.html`
 * (Screen3a, the "onConfirm" card), taken verbatim: the heading, the
 * intro line, the five field labels, and both button labels are copied
 * exactly as that file authors them. No lorem, no placeholder, no
 * developer-drafted wording.
 *
 * `fieldLabels` keys match `FIELDS` in `ConfirmDetailsRoute.tsx` — this is
 * the one place a confirm-details field id is paired with its on-screen
 * label, same single-home discipline `renewal-capture/content.ts`
 * documents for its own `sectionLabels` map.
 *
 * Business rule 10 (m1-portal-h2-fidelity): screen 3 carries no save notice, as H2 shows none.
 *
 * Field-validation error strings, if this route ever needs one, belong in
 * `src/web/src/validation/error-registry.ts` (ADR-20260918-htmd) — none is
 * authored yet because no field here has a stated validation rule.
 */
export const confirmDetailsContent = {
  eyebrow: "Step 1 of 3",
  heading: "Confirm your details",
  intro: "Check your business details are up to date.",

  fieldLabels: {
    businessName: "Business name",
    mailingAddress: "Mailing address",
    contactName: "Primary contact name",
    contactPhone: "Primary phone number",
    contactEmail: "Primary email address",
  } as Record<string, string>,

  continueLabel: "Continue",
  saveAndFinishLaterLabel: "Save and finish later",

  helpLine: "Need help? Contact your Account Manager.",
} as const;

/** Looks up a confirm-details field's authored label. Falls back to the
 * field id itself only for a field this content map has not been
 * authored for yet — never fabricates a plausible-looking label, same
 * fallback discipline as `renewal-capture/content.ts`'s `getSectionLabel`. */
export function getConfirmDetailsFieldLabel(fieldId: string): string {
  return confirmDetailsContent.fieldLabels[fieldId] ?? fieldId;
}
